import { zodSortField } from "@/lib/utils";
import { z } from "zod";

const aakAccountingFlags = ["F", "I", "T", "Z"] as const;
const deliveryNatures = ["L", "D", "R", "T"] as const;
const networkFlags = ["N", "O", "T"] as const;
const warrantyStarts = ["A"] as const;

export const getAakRulesRequestSchema = z.object({
  sort: zodSortField(["saleNature", "label", "createdAt"]),
});

export const addAakRuleSchema = z.object({
  saleNature: z
    .string()
    .length(1, "Le code nature de vente doit faire 1 caractère")
    .regex(/^[A-Z]$/, "Le code doit être une lettre majuscule"),
  label: z
    .string()
    .min(1, "Le libellé est requis")
    .max(200, "Maximum 200 caractères"),
  accountingFlag: z.enum(aakAccountingFlags, {
    errorMap: () => ({ message: "Flag AAK invalide (F, I, T ou Z)" }),
  }),
  fdmVgfStamp: z.boolean().default(false),
  deliveryNature: z.enum(deliveryNatures, {
    errorMap: () => ({
      message: "Nature de livraison invalide (L, D, R ou T)",
    }),
  }),
  networkFlag: z.enum(networkFlags, {
    errorMap: () => ({ message: "Flag réseau invalide (N, O ou T)" }),
  }),
  warrantyStart: z.enum(warrantyStarts).nullable().optional(),
});

export const editAakRuleSchema = z.object({
  id: z.number().int().positive(),
  saleNature: z
    .string()
    .length(1, "Le code nature de vente doit faire 1 caractère")
    .regex(/^[A-Z]$/, "Le code doit être une lettre majuscule"),
  label: z
    .string()
    .min(1, "Le libellé est requis")
    .max(200, "Maximum 200 caractères"),
  accountingFlag: z.enum(aakAccountingFlags, {
    errorMap: () => ({ message: "Flag AAK invalide (F, I, T ou Z)" }),
  }),
  fdmVgfStamp: z.boolean().default(false),
  deliveryNature: z.enum(deliveryNatures, {
    errorMap: () => ({
      message: "Nature de livraison invalide (L, D, R ou T)",
    }),
  }),
  networkFlag: z.enum(networkFlags, {
    errorMap: () => ({ message: "Flag réseau invalide (N, O ou T)" }),
  }),
  warrantyStart: z.enum(warrantyStarts).nullable().optional(),
  isActive: z.boolean().default(true),
  versionNote: z.string().max(500).optional(),
});

export const deleteAakRuleSchema = z.object({
  id: z.number().int().positive(),
});
